import React, { useMemo } from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import useEmpresa from "../../../hooks/useEmpresa";
import Colors from "../../../themes/Colors";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import { cleanNumber } from "../../../utils/NumberUtil";
import Tooltip from "../../../components/Common/Tooltip";
import CustomIcon from "../../../components/Common/CustomIcon";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  formatearMontoPesos,
  cleanCurrency,
} from "../../../utils/CurrencyUtil";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { camposRequeridosCompletos } from "../utils/IngresoUtils";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import { isEmptyValue } from "../../../utils/StringUtil";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import { dataTipoPss } from "../../../utils/LocalData";
import Spinner from "../../../components/Common/Spinner";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomButton from "../../../components/CustomButton/CustomButton";


const toNumber = (v) => {
  if (typeof v === "number") return v;
  if (typeof v === "string") {
    const cleaned = v.replace(/[^\d.-]/g, "");
    const n = Number(cleaned);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
};

const ProcedimientosIngresoTabla = (props) => {
  const { formCierreCuentasData, consultarReclamantesLoading, authUserData, agregarProcedimientoManual,
    showModalLoader } =
    props;
    
  const procedimientos = useMemo(() => {
  const arr = formCierreCuentasData?.procedimientos;
  return Array.isArray(arr) ? arr : [];
}, [formCierreCuentasData?.procedimientos]);

  const { prestador } = authUserData;

  const empresa = useEmpresa();

  const handleCodigoCobertura = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      codigoCobertura: cleanNumber(value),
    });
  };

  const onChangeFrecuencia = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      frecuenciaCobertura: cleanNumber(value),
    });
  };

  const handleChangeTipoPss = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      tipoPss: value,
      codigoPss: "",
      nombrePss: "",
    });
  };

  const onChangeMontoReclamado = (value) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      montoReclamado: cleanCurrency(value),
    });
  };

  const handleChangeCodigoReclamante = (value) => {
    if (!isEmptyValue(formCierreCuentasData?.tipoPss)) {
      const codigoPss = cleanNumber(value);

      props.formCierreCuentas({
        ...formCierreCuentasData,
        codigoPss,
      });

      props.consultarReclamantes({
        formCierreCuentasData,
        compania: empresa?.CODIGO,
        tipoReclamante: formCierreCuentasData?.tipoPss,
        codigoReclamante: codigoPss,
      });
      return;
    }
  };

  const onOpenModalProcedimientosPermitidos = () => {
    if (!camposRequeridosCompletos(formCierreCuentasData)) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }
    const { codigoPss, tipoPss } = formCierreCuentasData;
    if (
      isEmptyValue(tipoPss) ||
      isEmptyValue(codigoPss) ||
      Number(codigoPss) === 0
    ) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        tipoPss: prestador?.tipoPss,
        codigoPss: prestador?.codigo,
        showModalProcedimientosPermitidos: true,
      });
      return;
    }

    props.formCierreCuentas({
      ...formCierreCuentasData,
      showModalProcedimientosPermitidos: true,
    });
  };

  const eliminarProcedimiento = (procedimiento) => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      alertConfig: {
        type: "confirm",
        title: "¿Estás seguro?",
        message: `¿Deseas eliminar el procedimiento ${procedimiento?.cobertura}?`,
        onConfirm: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });

          props.eliminarProcedimientoCierreCuentas({
            formCierreCuentasData,
            formHandler: props.formCierreCuentas,
            procedimiento,
          });
        },
        onCancel: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });
        },
      },
      showAlert: true,
    });
  };
  

  /* =============== TOTALES (useMemo) =============== */
const totals = useMemo(() => {
  return procedimientos.reduce(
    (sum, it) => {
      sum.montoReclamado += toNumber(it?.montoReclamado);
      sum.montoAutorizado += toNumber(it?.montoAutorizado);
      sum.montoDiferencia += toNumber(it?.montoDiferencia);
      return sum;
    },
    { montoReclamado: 0, montoAutorizado: 0, montoDiferencia: 0 }
  );
}, [procedimientos]);


const totalRow = useMemo(
  () => ({
    key: "__total__",
    cobertura: "",
    nombreCobertura: "",
    tipoReclamante: "",
    codigoReclamante: "",
    nombreReclamante: "",
    limiteContrato: "",
    frecuencia: "",
    montoReclamado: totals.montoReclamado,
    montoAutorizado: totals.montoAutorizado,
    montoDiferencia: totals.montoDiferencia,
    coaseguro: "",
  }),
  [totals]
);
const dataWithTotal = useMemo(() => {
  const withIds = procedimientos.map((item, index) => {
    // Si es la fila inicial (key === 0), no le ponemos ID
    if (item?.key === 0) {
      return { ...item, id: "" };
    }
    // Para las demás, index empieza en 0 → le restamos 1 para que la cuenta empiece en 1
    return { ...item, id: index }; 
  });

  // fila total con id especial
  const total = { ...totalRow, id: "TOTAL:" };

  return [...withIds, total];
}, [procedimientos, totalRow]);


  const columnasProcedimientos = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text, record) => {
        if (record?.key === 0) {
          return ""; // primera fila sin ID
        }
        return <strong>{text}</strong>;  //los IDs numéricos en negrita
      },
    },
    {
      key: "cobertura",
      title: "Código",
      dataIndex: "cobertura",
      render: (text, record) => {
        return record?.key === 0 ? (
          <Section flexDirection={"row"}>
            <CustomIconInput
              type={"text"}
              value={formCierreCuentasData?.codigoCobertura}
              onChange={handleCodigoCobertura}
              placeholder={"Código"}
              width={"100px"}
              display={"flex"}
            />
            <CustomSeparator width={"5px"} />
            <Tooltip text="Buscar">
              <CustomIcon
                icon={SearchOutlined}
                style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
                hoverColor={empresa?.COLOR_SECUNDARIO}
                onClick={onOpenModalProcedimientosPermitidos}
              />
            </Tooltip>
          </Section>
        ) : (
          text
        );
      },
    },
    {
      key: "nombreCobertura",
      title: "Descripción",
      dataIndex: "nombreCobertura",
      render: (text, record) => {
      // Fila de inputs (key === 0): mostrar botón Agregar Procedimiento
      if (record?.key === 0) {
        return (
          <CustomButton
            label={"Agregar Procedimiento"}
            onClick={agregarProcedimientoManual}
            disabled={showModalLoader()}
            weight={"bold"}
            height={"45px"}
            hoverColor={empresa?.COLOR_PRINCIPAL}
            bgColor={Colors.white}
            textColor={empresa?.COLOR_PRINCIPAL}
            border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
          />
        );
      }

      // Resto de filas: mostrar el texto normal
      return text;
  },
    },
    {
      key: "tipoReclamante",
      title: "Tipo reclamante",
      dataIndex: "tipoReclamante",
      render: (text, record) => {
        return record?.key === 0 && !prestador?.esPaquete ? (
          <CustomSelect
            options={dataTipoPss}
            showDefaultOption={true}
            value={formCierreCuentasData?.tipoPss}
            onChange={handleChangeTipoPss}
            disabled={false}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "codigoReclamante",
      title: "Código reclamante",
      dataIndex: "codigoReclamante",
      render: (text, record) => {
        return record?.key === 0 && !prestador?.esPaquete ? (
          <CustomIconInput
            type={"text"}
            value={formCierreCuentasData?.codigoPss}
            onChange={handleChangeCodigoReclamante}
            placeholder={"Código"}
            width={"100px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "nombreReclamante",
      title: "Reclamante",
      dataIndex: "nombreReclamante",
      render: (text, record) => {
        if (record?.key === 0) {
          return consultarReclamantesLoading ? (
            <Spinner size={10} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
          ) : (
            formCierreCuentasData?.nombrePss
          );
        }
        return text;
      },
    },
    {
      key: "limiteContrato",
      title: "Limite contrato",
      dataIndex: "limiteContrato",
      render: (text) => formatearMontoPesos(String(text)),
    },
    {
      key: "frecuencia",
      title: "Frecuencia",
      dataIndex: "frecuencia",
      render: (text, record) => {
        return record?.key === 0 ? (
          <CustomIconInput
            type={"text"}
            value={formCierreCuentasData?.frecuenciaCobertura}
            onChange={onChangeFrecuencia}
            placeholder={"Frecuencia"}
            width={"80px"}
          />
        ) : (
          text
        );
      },
    },
    {
      key: "montoReclamado",
      title: "Monto reclamado",
      dataIndex: "montoReclamado",
      render: (text, record) =>
      record?.key === "__total__"
      ? <strong>{formatearMontoPesos(String(text ?? 0))}</strong>
      : formatearMontoPesos(String(text ?? 0)),
    },
    {
      key: "montoAutorizado",
      title: "Monto a pagar ARS",
      dataIndex: "montoAutorizado",
      render: (text, record) =>
      record?.key === "__total__"
      ? <strong>{formatearMontoPesos(String(text ?? 0))}</strong>
      : formatearMontoPesos(String(text ?? 0)),
    },
    {
      key: "montoDiferencia",
      title: "Diferencia no cubierta",
      dataIndex: "montoDiferencia",
      render: (text, record) =>
      record?.key === "__total__"
      ? <strong>{formatearMontoPesos(String(text ?? 0))}</strong>
      : formatearMontoPesos(String(text ?? 0)),
    },
    {
      key: "coaseguro",
      title: "% coaseguro",
      dataIndex: "coaseguro",
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) =>
        record?.key !== 0 && record?.key !== "__total__" ? (   //se agregó la condición para el total
          <Tooltip text="Eliminar">
            <DeleteOutlined
              style={{ color: Colors.huMyHealth, fontSize: 25 }}
              onClick={() => eliminarProcedimiento(record)}
            />
          </Tooltip>
        ) : null,
      },
  ];

  return (
    <CustomTable
      columns={columnasProcedimientos}
      dataSource={dataWithTotal  || []}
      showPagination={false}
      pageSize={100}
      width={"200%"}
      maxWidth={"1400px"}
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarReclamantesLoading: state.ingreso.consultarReclamantesLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  eliminarProcedimientoCierreCuentas:
    IngresoActions.eliminarProcedimientoCierreCuentas,
  consultarReclamantes: IngresoActions.consultarReclamantes,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProcedimientosIngresoTabla);
